import { getGoogleAnalyticsClientId } from '@/lib/analytics/hooks/client-id';
import { sendHubxEventPayload } from '@/lib/analytics/services/send-hubx-event';
import { getUtmParams } from '@/lib/analytics/utils/get-utm-params';
import { selectAuth } from '@/store/slices/authSlice';

import { buildHubxPayload, type LogHubxEventParams } from './log-hubx-event-adapter';

interface QueuedEvent {
  params: LogHubxEventParams;
  currentUrl: string;
  firstVisitTimestamp: string;
  eventTimestamp: string;
  auth: ReturnType<typeof selectAuth>;
  utmParams: ReturnType<typeof getUtmParams>;
}

const eventQueue: QueuedEvent[] = [];
let isProcessingQueue = false;

export function queueHubxEvent(event: QueuedEvent) {
  eventQueue.push(event);
}

export async function processEventQueue() {
  if (isProcessingQueue) {
    return;
  }

  isProcessingQueue = true;

  const clientId = getGoogleAnalyticsClientId();

  if (!clientId) {
    setTimeout(() => {
      isProcessingQueue = false;
      void processEventQueue();
    }, 100);

    return;
  }

  while (eventQueue.length > 0) {
    const {
      params,
      currentUrl,
      firstVisitTimestamp,
      eventTimestamp,
      auth,
      utmParams,
    } = eventQueue.shift()!;

    await sendHubxEventPayload(
      buildHubxPayload(
        params,
        auth,
        utmParams,
        currentUrl,
        firstVisitTimestamp,
        eventTimestamp,
        clientId
      )
    );
  }

  isProcessingQueue = false;
}
